module.exports = __webpack_public_path__ + "static/img/6.3f8db01.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/1/1/2/eng/6.png
// module id = po+P
// module chunks = 0